import { LeoRPCResult, parseResponse } from "@surya-digital/leo-ts-types";
import { APIClient, Request, Method } from "@surya-digital/tedwig";
import { GetEmailCycleRecipientsRPC } from "./getEmailCycleRecipientsRPC";

export class GetEmailCycleRecipientsRPCClientImpl extends GetEmailCycleRecipientsRPC {
  readonly client: APIClient;

  constructor(client: APIClient) {
    super();
    this.client = client;
  }

  async execute(request: GetEmailCycleRecipientsRPC.Request): Promise<LeoRPCResult<GetEmailCycleRecipientsRPC.Response, GetEmailCycleRecipientsRPC.Errors.Errors>> {
    const requestBody = request.toDTO();
    const response = await this.client.sendRequest(
      new Request(
        Method.Post,
        "email-cycle/GetEmailCycleRecipients",
        undefined,
        undefined,
        requestBody
      )
    );
    return parseResponse<
      GetEmailCycleRecipientsRPC.ResponseDTO,
      GetEmailCycleRecipientsRPC.Errors.ErrorsDTO,
      GetEmailCycleRecipientsRPC.Response,
      GetEmailCycleRecipientsRPC.Errors.Errors
    >(
      response,
      "email-cycle/GetEmailCycleRecipients",
      GetEmailCycleRecipientsRPC.Response.fromDTO,
      GetEmailCycleRecipientsRPC.Errors.fromDTO
    );
  }
}
